import { httpFetch } from '../../Utils/httpUtils'
import commonActions from '../commonActions'
import { commonActionTypes } from '../../ActionTypes/commonActionTypes'

const eventsActions = {

    resendApplicationAddedToEmployee(employeeId, applicationId, callback) {
        return dispatch => {
            dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "resendEmployeeEvent", value: true });
            const httpRequest = {
                method: 'POST',
                body: JSON.stringify({
                    employeeId: employeeId,
                    applicationId: applicationId
                })
            }
            return httpFetch('/api/Events/ResendApplicationAddedToEmployee', dispatch, httpRequest)
                .then(json => {
                    if (callback) {
                        callback();
                    }
                    dispatch(commonActions.showSuccess('Event has been republished!'));
                })
                .finally(() => {
                    dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "resendEmployeeEvent", value: false });
                })
        }
    },

    resendApplicationAddedToCustomer(customerId, productFamilyId, callback) {
        return dispatch => {
            dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "resendCustomerEvent", value: true });
            const httpRequest = {
                method: 'POST',
                body: JSON.stringify({
                    customerId: customerId,
                    productFamilyId: productFamilyId
                })
            }
            return httpFetch('/api/events/resendapplicationaddedtocustomer', dispatch, httpRequest)
                .then(json => {
                    if (callback) {
                        callback();
                    }
                    dispatch(commonActions.showSuccess('Event has been republished!'));
                })
                .finally(() => {
                    dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "resendCustomerEvent", value: false });
                })
        }
    }
}

export default eventsActions;